/** Backend stage names (dash.pipeline.DashboardStages) → Dashboards.run.stages.* keys. */
const STAGE_KEYS = {
  dashboard_planning: 'planning',
  widget_framing: 'planning',
  dashboard_table_narrowing: 'table_narrowing',
  widget_data_intent: 'data_intent',
  widget_sql_generation: 'sql_generation',
  widget_sql_execution: 'sql_execution',
  binding_execution: 'sql_execution',
  widget_visual_spec: 'visual_spec',
  widget_figure_compile: 'figure',
  figure_compile: 'figure',
  widget_caption: 'caption',
  widget_freeze: 'assembly',
  dashboard_assembly: 'assembly',
  dashboard_edit_framing: 'edit_framing',
  dashboard_meta_response: 'edit_framing',
  edit_op_validation: 'apply',
  edit_routing: 'apply',
  blast_radius_check: 'apply',
  edit_commit: 'apply',
  ux_edit: 'apply',
  pin_from_chat: 'apply',
  widget_repair: 'repair',
};

export const stageLabel = (t, stage) => {
  if (!stage) return '';
  const key = STAGE_KEYS[stage] || STAGE_KEYS[String(stage).toLowerCase()];
  return key ? t(`Dashboards.run.stages.${key}`) : String(stage).replace(/_/g, ' ');
};
